import { setAllowsAction } from '../action';
import { getProfile } from '../api/getProfile';

export const setGetProfile = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getProfile(params);
            if (data.status === 'success') {
                dispatch(setAllowsAction(data.data.allow))
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}